import { Navigate } from 'react-router-dom';
import { ROUTES } from '@/config/app.config';
import { useAuthStore } from '@/stores/use-auth-store';

interface AdminRouteProps {
    children: React.ReactNode;
}

export function AdminRoute({ children }: AdminRouteProps) {
    const { isAuthenticated, user } = useAuthStore();

    if (!isAuthenticated) {
        return <Navigate to={ROUTES.login} replace />;
    }

    if (user?.role !== 'admin') {
        return <Navigate to={ROUTES.dashboard} replace />;
    }

    return <>{children}</>;
}

export default AdminRoute;
